export default "__VITE_ASSET__DlhzfEU8__"